import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "container-centered small-2"
  }, [_c("div", {
    attrs: {
      id: "container-card"
    }
  }), _vm.errorMessage ? _c("div", {
    staticClass: "errorLabel",
    attrs: {
      role: "alert"
    }
  }, [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")]) : _vm._e(), _c("div", {
    staticClass: "btn-save"
  }, [_c(VBtn, {
    staticClass: "dfwa-btn --small",
    attrs: {
      rounded: true,
      disabled: !_vm.isValid
    },
    on: {
      click: function click($event) {
        return _vm.saveCreditCard();
      }
    }
  }, [_vm._v(" Save ")])], 1), _c(VDivider, {
    staticClass: "divider"
  })], 1), _vm.list.length > 0 ? [_c("div", {
    staticClass: "mb-4"
  }, [_vm._v("Saved credit cards")])] : _vm._e(), _c("section", {
    staticClass: "container-payments"
  }, [_vm.isLoading ? _c(VSkeletonLoader, {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "image"
    }
  }) : _vm.list.length === 0 ? [_c("div", [_vm._v("No credit card saved")])] : _vm.list.length > 0 ? _vm._l(_vm.list, function (cc) {
    return _c("div", {
      key: cc.id_stripe_credit_card,
      staticClass: "card-payment"
    }, [_c("div", {
      staticClass: "card-wallet card"
    }, [_c("div", {
      staticClass: "card__front card__part"
    }, [_c("div", {
      staticClass: "card_brand"
    }, [_c("p", {
      staticClass: "card_brand_title"
    }, [_c("i", {
      staticClass: "far fa-credit-card"
    }), _vm._v(" " + _vm._s(cc.brand) + " ")]), _c("div", {
      staticClass: "btn-delete",
      attrs: {
        title: _vm.numberOfPaymentMethods > 1 && cc.default ? "Please set an other default payment method to be allowed to delete it" : ""
      }
    }, [_c(VBtn, {
      staticClass: "dfwa-btn --small-2",
      attrs: {
        rounded: "",
        disabled: _vm.numberOfPaymentMethods > 1 && cc.default
      },
      on: {
        click: function click($event) {
          return _vm.deleteCard(cc.payment_method_id);
        },
        shortkey: function shortkey($event) {
          return _vm.deleteCard(cc.payment_method_id);
        }
      }
    }, [_c(VIcon, {
      attrs: {
        small: "",
        dark: ""
      }
    }, [_vm._v("mdi-delete")])], 1)], 1)]), _c("p", {
      staticClass: "card_number"
    }, [_vm._v("**** **** **** " + _vm._s(cc.last4))]), _c("div", {
      staticClass: "card__footer gap-4"
    }, [_c("div", [_c("span", {
      staticClass: "card__label"
    }, [_vm._v("Card holder")]), _c("p", {
      staticClass: "card__info"
    }, [_vm._v(_vm._s(_vm.getFullNameUser(_vm.user)))])]), _c("div", [_c("span", {
      staticClass: "card__label"
    }, [_vm._v("Expires")]), _c("p", {
      staticClass: "card__info"
    }, [_vm._v("0" + _vm._s(cc.exp_month) + "/" + _vm._s(cc.exp_year))])])])])]), _vm.numberOfPaymentMethods > 1 && !cc.default ? _c(VBtn, {
      staticClass: "dfwa-btn --small-2 secondary",
      attrs: {
        rounded: ""
      },
      on: {
        click: function click($event) {
          return _vm.setDefaultPayment(cc);
        }
      }
    }, [_vm._v(" Set as default payment ")]) : _vm._e()], 1);
  }) : _vm._e()], 2), _c("confirm", {
    ref: "confirm"
  })], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };